<template>
	<div>
		<svg
			:width="size"
			:height="size"
			viewBox="0 0 14 13"
			:fill="color"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M7.89258 7C7.89258 7.27614 7.66872 7.5 7.39258 7.5C7.11644 7.5 6.89258 7.27614 6.89258 7C6.89258 6.72386 7.11644 6.5 7.39258 6.5C7.66872 6.5 7.89258 6.72386 7.89258 7Z"
				:fill="color"
			/>
			<path
				d="M4.39258 9C4.66872 9 4.89258 8.77614 4.89258 8.5C4.89258 8.22386 4.66872 8 4.39258 8C4.11644 8 3.89258 8.22386 3.89258 8.5C3.89258 8.77614 4.11644 9 4.39258 9Z"
				:fill="color"
			/>
			<path
				d="M4.89258 10C4.89258 10.2761 4.66872 10.5 4.39258 10.5C4.11644 10.5 3.89258 10.2761 3.89258 10C3.89258 9.72386 4.11644 9.5 4.39258 9.5C4.66872 9.5 4.89258 9.72386 4.89258 10Z"
				:fill="color"
			/>
			<path
				d="M5.89258 9C6.16872 9 6.39258 8.77614 6.39258 8.5C6.39258 8.22386 6.16872 8 5.89258 8C5.61644 8 5.39258 8.22386 5.39258 8.5C5.39258 8.77614 5.61644 9 5.89258 9Z"
				:fill="color"
			/>
			<path
				d="M6.39258 10C6.39258 10.2761 6.16872 10.5 5.89258 10.5C5.61644 10.5 5.39258 10.2761 5.39258 10C5.39258 9.72386 5.61644 9.5 5.89258 9.5C6.16872 9.5 6.39258 9.72386 6.39258 10Z"
				:fill="color"
			/>
			<path
				d="M7.39258 9C7.66872 9 7.89258 8.77614 7.89258 8.5C7.89258 8.22386 7.66872 8 7.39258 8C7.11644 8 6.89258 8.22386 6.89258 8.5C6.89258 8.77614 7.11644 9 7.39258 9Z"
				:fill="color"
			/>
			<path
				d="M7.89258 10C7.89258 10.2761 7.66872 10.5 7.39258 10.5C7.11644 10.5 6.89258 10.2761 6.89258 10C6.89258 9.72386 7.11644 9.5 7.39258 9.5C7.66872 9.5 7.89258 9.72386 7.89258 10Z"
				:fill="color"
			/>
			<path
				d="M8.89258 9C9.16872 9 9.39258 8.77614 9.39258 8.5C9.39258 8.22386 9.16872 8 8.89258 8C8.61644 8 8.39258 8.22386 8.39258 8.5C8.39258 8.77614 8.61644 9 8.89258 9Z"
				:fill="color"
			/>
			<path
				d="M9.39258 10C9.39258 10.2761 9.16872 10.5 8.89258 10.5C8.61644 10.5 8.39258 10.2761 8.39258 10C8.39258 9.72386 8.61644 9.5 8.89258 9.5C9.16872 9.5 9.39258 9.72386 9.39258 10Z"
				:fill="color"
			/>
			<path
				d="M10.3926 9C10.6687 9 10.8926 8.77614 10.8926 8.5C10.8926 8.22386 10.6687 8 10.3926 8C10.1164 8 9.89258 8.22386 9.89258 8.5C9.89258 8.77614 10.1164 9 10.3926 9Z"
				:fill="color"
			/>
			<path
				d="M9.39258 7C9.39258 7.27614 9.16872 7.5 8.89258 7.5C8.61644 7.5 8.39258 7.27614 8.39258 7C8.39258 6.72386 8.61644 6.5 8.89258 6.5C9.16872 6.5 9.39258 6.72386 9.39258 7Z"
				:fill="color"
			/>
			<path
				d="M10.3926 7.5C10.6687 7.5 10.8926 7.27614 10.8926 7C10.8926 6.72386 10.6687 6.5 10.3926 6.5C10.1164 6.5 9.89258 6.72386 9.89258 7C9.89258 7.27614 10.1164 7.5 10.3926 7.5Z"
				:fill="color"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M3.89258 0C4.16872 0 4.39258 0.223858 4.39258 0.5V1.5H10.3926V0.5C10.3926 0.223858 10.6164 0 10.8926 0C11.1687 0 11.3926 0.223858 11.3926 0.5V1.5H11.8926C12.9971 1.5 13.8926 2.39543 13.8926 3.5V11C13.8926 12.1046 12.9971 13 11.8926 13H2.89258C1.78801 13 0.892578 12.1046 0.892578 11V3.5C0.892578 2.39543 1.78801 1.5 2.89258 1.5H3.39258V0.5C3.39258 0.223858 3.61644 0 3.89258 0ZM12.8926 6C12.8926 5.44772 12.4449 5 11.8926 5H2.89258C2.34029 5 1.89258 5.44772 1.89258 6V11C1.89258 11.5523 2.34029 12 2.89258 12H11.8926C12.4449 12 12.8926 11.5523 12.8926 11V6Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgUnion',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
